"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fileStatus = require("./fileStatus");
var _default = exports["default"] = {
  ausbildungsNachweisSort: function ausbildungsNachweisSort(result, canVerify) {
    result.sort(function (a, b) {
      return a.nummer - b.nummer;
    });
    result.reverse();
    if (!canVerify) {
      return result;
    }
    var abgelehntArray = result.filter(function (el) {
      return el.status === _fileStatus.statusTypes.abgelehnt;
    });
    var eingereichtArray = result.filter(function (el) {
      return el.status === _fileStatus.statusTypes.eingereicht;
    });
    var freigegebenArray = result.filter(function (el) {
      return el.status === _fileStatus.statusTypes.freigegeben;
    });
    return eingereichtArray.concat(abgelehntArray).concat(freigegebenArray);
  }
};